import React, { useState, useEffect } from 'react';
import './ElspotReadOnlyValue.css';

const ElspotReadOnlyValue = ({ header, inputValue }) => {
  const [value, setValue] = useState(inputValue);

  useEffect(() => {
    setValue(inputValue);
  }, [inputValue]);

  return (
    <div className="input-container">
      <span className="elspot-readonlyevalue-header">{header}</span>
      <input type="text" value={value ?? ''} readOnly className='input-field' />
    </div>
  );
};

export default ElspotReadOnlyValue;
